import {
  Sparkles,
  BedDouble,
  Stamp,
  Car,
  Heart,
  Users,
} from "lucide-react";
import { SERVICES } from "@/lib/site-data";
import FadeIn from "@/components/FadeIn";

const ICONS = {
  sparkles: Sparkles,
  hotel: BedDouble,
  stamp: Stamp,
  car: Car,
  heart: Heart,
  users: Users,
};

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 sm:py-32 bg-[#FAFAFA]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <FadeIn>
            <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] text-[#2C7A7B]">
              <span className="h-px w-8 bg-[#2C7A7B]" />
              Our Services
            </div>
          </FadeIn>
          <FadeIn delay={100}>
            <h2 className="mt-5 font-display text-[#0F3D3E] text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              One team.{" "}
              <span className="italic">Every detail.</span>
            </h2>
          </FadeIn>
          <FadeIn delay={200}>
            <p className="mt-6 text-[#0A0A0A]/70 leading-relaxed">
              From the first daydream to the last boarding pass — we handle the
              logistics so your holiday stays a holiday.
            </p>
          </FadeIn>
        </div>

        <div className="mt-14 sm:mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
          {SERVICES.map((svc, i) => {
            const Icon = ICONS[svc.icon];
            return (
              <FadeIn
                key={svc.title}
                delay={i * 70}
                data-testid={`service-card-${svc.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="group relative rounded-3xl bg-white border border-[#0F3D3E]/8 p-7 sm:p-8 hover:border-[#2C7A7B]/40 hover:-translate-y-1 hover:shadow-[0_20px_60px_-20px_rgba(15,61,62,0.18)] transition-all duration-500 overflow-hidden"
              >
                <div className="absolute -top-10 -right-10 size-40 rounded-full bg-[#F4EDE4] opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="relative">
                  <div className="size-12 rounded-2xl bg-[#0F3D3E] text-[#F4EDE4] flex items-center justify-center group-hover:bg-[#2C7A7B] transition-colors">
                    <Icon size={22} strokeWidth={1.6} />
                  </div>
                  <h3 className="mt-6 font-display text-2xl text-[#0F3D3E] leading-snug">
                    {svc.title}
                  </h3>
                  <p className="mt-3 text-[#0A0A0A]/70 text-sm leading-relaxed">
                    {svc.body}
                  </p>
                </div>
              </FadeIn>
            );
          })}
        </div>
      </div>
    </section>
  );
}
